<ion-content *ngIf="!error" class="content" slp-ionic-platform readonly="readonly">
  <ion-item *ngIf="!readonly" lines="none">
    <p>{{ "administration.permissions.title" | translate }}</p>
  </ion-item>

  <ion-item lines="none" [class.errorMessage]="hasClaims" [class.message]="!hasClaims">
    <ion-text *ngIf="hasClaims">{{ "administration.permissions.messageAtLeastOneClaim" | translate }}</ion-text>
  </ion-item>

  <ion-segment [value]="currentContent" (ionChange)="segmentChanged($event)">
    <ion-segment-button value="roles">
      <ion-label> {{ "administration.permissions.roles" | translate }} ({{rolesCount}})</ion-label>
    </ion-segment-button>
    <ion-segment-button value="claims">
      <ion-label> {{ "administration.permissions.claims" | translate }} ({{claimsCount}})</ion-label>
    </ion-segment-button>
  </ion-segment>
  <ion-list *ngIf="currentContent === 'roles'">
    <ion-item class="roleItem" *ngFor="let role of permissions?.roles">
      <ion-toggle slot="end" class="child-toggle" color="tertiary" [(ngModel)]="role.isSelected" aria-label=""
        [disabled]="readonly || checkDisableGrantOptionForRole(role)" (ionChange)="toggleRole(role, $event)">
      </ion-toggle>
      <ion-text>
        <h6>{{ role.name }}</h6>
        <p>
          <ng-container *ngFor="let claim of role.claims; let claimIndex = index"> {{ claim.displayName + (claimIndex
            === role.claims?.length - 1 ? '' : ',') }} </ng-container>
        </p>
      </ion-text>
    </ion-item>
  </ion-list>
  <ion-accordion-group *ngIf="currentContent === 'claims'">
    <ion-item *ngIf="!readonly" lines="none">
      <p>{{ "administration.permissions.claimsMessage" | translate }}</p>
    </ion-item>
    <ion-accordion *ngFor="let claimGroup of permissions?.claims" [value]="claimGroup.claimGroupName">
      <ion-item slot="header">
        <ion-icon slot="start" name="chevron-up-outline" class="ion-accordion-toggle-icon"></ion-icon>
        <ion-toggle appClickNoPropagate slot="end" color="primary" class="parent-toggle" aria-label=""
          [disabled]="readonly || !claimGroup.isActive || (!claimGroup.isSelected && checkDisableGrantOptionForRole(claimGroup)) || checkDisableIfRoleIsAssigned(claimGroup,true)"
          [checked]="claimGroup.isSelected" (ionChange)="toggleClaimGroup(claimGroup, $event)">
        </ion-toggle>
        <ion-label appClickNoPropagate class="toggle-label">{{ claimGroup.claimGroupName }}</ion-label>
        <ion-label appClickNoPropagate class="toggle-label summary">{{ "administration.permissions.claimsSummary" |
          translate: { selectedClaims: claimGroup?.selectedClaims, totalClaims: claimGroup?.claims.length }
          }}</ion-label>
      </ion-item>
      <ion-list slot="content">
        <ion-item *ngFor="let claim of claimGroup?.claims">
          <ion-toggle slot="end" class="child-toggle" color="tertiary" aria-label=""
            [disabled]="readonly || !claim.isActive || checkDisableGrantOptionForClaim(claim) || checkDisableIfRoleIsAssigned(claimGroup)"
            [(ngModel)]="claim.isSelected" (ionChange)="toggleClaim(claim, $event)">
          </ion-toggle>
          <ion-label>
            <h6>{{ claim.displayName }}</h6>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-accordion>
  </ion-accordion-group>
</ion-content>
<div *ngIf="error" class="ion-text-center error-load">
  <h5>{{ "administration.InternalError" | translate }}</h5>
</div>